module.exports = __webpack_public_path__ + "img/logo.37cd4c0f.png";